__turbopack_context__.v({
  "className": "TMkHfG_className",
  "variable": "TMkHfG_variable",
});
